import { httpClientSessionManager } from 'dashboard-experience/shared/services'
import { type SessionWebResponse } from '../entities'

export const getSessionWeb = async ({ currentStoneAccountId = '' }) => {
  const response = await httpClientSessionManager<SessionWebResponse>({
    url: '/api/v1/session-manager/web/session',
    method: 'GET',
    params: {
      current_stone_account_id: currentStoneAccountId
    }
  })

  return response.data
}
